// extracted by mini-css-extract-plugin
export default {"vhidden":"Title_vhidden__0WL43","h1":"Title_h1__FySzP","h2":"Title_h2__YZ00W","h3":"Title_h3__P3D5x"};